var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateProfessionalHotlineRequest } from '@/actions/ProfessionalHotlineActions';
import Layout from '@/container/Layout';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { HotlineProFirstReplyConfirmView } from '@/feature/hotline/professional/firstReply/confirm/page/HotlineProFirstReplyConfirmView';
import { getHotlineProFirstReplySubmitValues } from '@/feature/hotline/professional/firstReply/util/getHotlineProFirstReplySubmitValues';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { pagePath } from '@/utils/router/pagePath';
/**
 * ホットライン 初回返信 確認画面（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineProFirstReplyConfirmPage = (props) => {
    const { formValues, id, title } = props;
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const onSubmit = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        // 申し込みを実行
        yield wrapDispatch(dispatch, apiCreateProfessionalHotlineRequest({
            json: getHotlineProFirstReplySubmitValues(formValue),
            path: { id },
        }, {}));
        if (!unmountRef.current) {
            // 送信後は完了画面へ遷移
            history.push(pagePath.hotline.professional.firstReplyComplete(id));
        }
    }), [dispatch, history, id, unmountRef]);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.professional.firstReplyConfirm(id), title: `${title} 初回返信 - 確認 | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProFirstReplyConfirmView, { defaultValues: formValues, id: id, onSubmit: onSubmit, title: title }) }))] }));
};
